import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import WorkPage from './pages/WorkPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import LogPage from './pages/LogPage';
import WritingDetailPage from './pages/WritingDetailPage';
import ContactPage from './pages/ContactPage';
import PreviewPage from './pages/PreviewPage';
import AdminLoginPage from './pages/admin/AdminLoginPage';
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import AdminProjectFormPage from './pages/admin/AdminProjectFormPage';
import AdminFeaturedPage from './pages/admin/AdminFeaturedPage';
import AdminContactPage from './pages/admin/AdminContactPage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/work" element={<WorkPage />} />
        <Route path="/work/:id" element={<ProjectDetailPage />} />
        <Route path="/log" element={<LogPage />} />
        <Route path="/log/:id" element={<WritingDetailPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/preview" element={<PreviewPage />} />
        <Route path="/admin" element={<AdminLoginPage />} />
        <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
        <Route path="/admin/projects/new" element={<AdminProjectFormPage />} />
        <Route path="/admin/projects/:id/edit" element={<AdminProjectFormPage />} />
        <Route path="/admin/featured" element={<AdminFeaturedPage />} />
        <Route path="/admin/contact" element={<AdminContactPage />} />
      </Routes>
    </BrowserRouter>
  );
}
